import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGifToVideoConverterConfig } from '@/data/landingConfig/landingGifToVideoConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GifToVideoConverter } from './schemaObject';

interface Props {}
const GifToVideoConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GifToVideoConverter} />
			<VideoLandingTemplate
				data={landingGifToVideoConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default GifToVideoConverter;
